//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            loading: false,
            classrooms: [],
            pagination: {}
        };
    },

    computed: {
        params () {
            let params = {};

            params.limit = 6;
            params.page = this.pagination.currentPage;
            params.sort = 'start|desc';
            params.filter = ['testclass|0'];

            return params;
        }
    },

    mounted () {
        this.loadData();
    },

    methods: {
        loadData () {
            this.loading = true;

            axios.get('classrooms', {
                params: this.params
            }).then(response => {
                this.classrooms = response.data.data;
                this.pagination = this.$helper.getPaginationData(response);
                this.loading = false;
            }).catch(error => {
                console.log(error);
                this.loading = false;
            });
        },
        goToPage (page) {
            this.pagination.currentPage = page;
            this.loadData();
        }
    }
};
